<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="after-the-bombs-ryan-angel-and-madi-2">
<h1>After the Bombs: Ryan, Angel and Madi</h1>
<p>There were ten big caravans parked in a circle. In the centre of the circle, there was a huge campfire, with different cooking stations on it. There was a collection of pots and pans and kettles on or around the fire. Some pans had vegetables in them and there looked like a pot of coffee on the side. In front of all the caravans were picnic tables and chairs, a collection of mis-matched items of all shapes, sizes and colours.</p>
<p>Behind the caravans, there was a refrigerated van and a freezer van. To the back of the camp, against the trees, there was a makeshift animal shelter. In the shelter, there was a horse, a donkey, two alpacas and a zebra with her foal.</p>
<p>Taking in the bizarre scene, Ryan parked the car, he said to Angel to watch the car clock, if he didn’t come back in 15mins, then she was to drive away and not look back.</p>
<p>‘No way,’ said Angel, ‘we are in this together, so we stick together. If you are going in, then we are coming with you.’</p>
<p>Ryan beamed at Angel, finally someone wanted to be with him. ‘Ok then,’ he said, ‘Let’s see what’s going on in here. What’s the worst that can happen.’</p>
<p>‘Welcome, welcome, welcome, fellow travellers one and all. I am Brahm, the leader of this merry camp and this is my wife Ophelia.’</p>
<p>’This is my brother Jonah and his wife Celeste, then we have the three Jeanies and our father Rahoul.</p>
<p>There are a few others here and there and you will meet them all in your own good time.’</p>
<p>Ryan said, ‘Hi I’m Ryan and this is Angel and this is Madi.’</p>
<p>‘Wonderful, wonderful, wonderful,’ said Brahm.</p>
<p>Ryan and Angel both looked at each other and wondered if Brahm always said everything three times, but they felt it would be rude to ask.</p>
<p>‘Come, come, come, sit by the fire and have some food and something to drink,’ said Brahm.</p>
<p>‘Are you hungry,’ asked Ophelia. ‘Yes, we are very hungry,’ replied Angel.</p>
<p>Plates of very thick vegetable soup were passed round along with what looked like homemade bread.</p>
<p>They ate their food and felt quite revived. ‘Thank you so much for feeding us’ Angel said to Ophelia. ‘You are more than welcome,’ was her reply.</p>
<p>‘Now then, now then, now then,’ said Brahm, ‘there’s a few empty caravans in the circle, so you are welcome to pick one to sleep in.’</p>
<p>‘Thank you,’ said Angel, ‘you are all so very kind.’</p>
<p>And off they went with Ophelia to find a suitable caravan.</p>
<p>Brahm rubbed his hands together and said, ‘Lovely, lovely, lovely,’ as he watched Angel help Madi through the caravan door.</p>
<p>The next morning Madi woke early, therefore Ryan and Angel were up early too.</p>
<p>They were still sleeping in their clothes, so they just got up and went out to join the others.</p>
<p>Everyone sat on the garden furniture that was doted around the fire.</p>
<p>As Ryan, Angel and Madi approached, Brahm shouted, ‘Good Morning, Good Morning, Good Morning. Come sit near me and we will get you some breakfast.’</p>
<p>Ryan, Angel and Madi joined Brahm at a green plastic table while Ophelia set about getting them some breakfast.</p>
<p>Bowls of porridge appeared and glasses of orange squash. They were very hungry so they wasted no time and tucked straight in. Once the bowls were empty, they thanked both Brahm and Ophelia.</p>
<p>After breakfast, they wandered around the camp taking a close look at everything.</p>
<p>Once they were sure that they had seen it all and Madi had fed some of the animals, they decided to move on to explore Inch Village.</p>
<p>It was very badly damaged but not totally destroyed. There was a small shop which was partially still standing, but when they entered it, it was nearly bare.</p>
<p>‘The travellers will have taken all the food to their camp,’ said Ryan, ‘that’s what they will have been living on.’</p>
<p>They had a look in the few houses that were still standing, and again there was not a scrap of food left in any of them.</p>
<p>They wandered back to camp thinking about what they could do next.</p>
<p>Brahm welcomed them back as if they had been gone for weeks, not hours.</p>
<p>‘Ah you’re back, you’re back, you’re back,’ he said.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch023.vue?4fdd8614